import { useCallback, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from 'redux/toolkit/hooks'

import LANGUAGE_NAMES from 'config/i18n/common'
import { setLanguage } from 'redux/features/app/appSlice'

export interface UseLanguageMenuDialogLogic {
  selectedLanguage: string
  handleSelectLanguage: (currentLanguage: string) => void
  availableLanguages: Array<{ label: string; code: string }>
}

export const useLanguageMenuDialogLogic = () => {
  const dispatch = useAppDispatch()
  const { preferredLanguage } = useAppSelector(_store => ({
    preferredLanguage: _store.app.language
  }))

  const languageOptions = useMemo(
    () =>
      Object.keys(LANGUAGE_NAMES.ess_language.language).map(code => ({
        label: LANGUAGE_NAMES.ess_language.language[code as keyof typeof LANGUAGE_NAMES.ess_language.language] || code,
        code
      })),
    []
  )

  const handleSelectLanguage = useCallback(
    (currentLanguage: string) => {
      dispatch(setLanguage(currentLanguage))
    },
    [dispatch]
  )

  return {
    selectedLanguage: preferredLanguage,
    handleSelectLanguage,
    availableLanguages: languageOptions
  }
}
